'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useState } from 'react';
import { usePartnerList } from '@/app/cc/_apis/ansimPartner/usePartnerList';
import BottomSheet from '@/app/cc/_component/ui/common/BottomSheet/BottomSheet';
import LocSheet from '@/app/cc/_component/ui/common/BottomSheet/LocSheet/LocSheet';
import Button from '@/app/cc/_component/ui/common/Button/Button';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/AnsimPartner/AnsimPartner.module.scss';
import { useGetDealType } from '@/app/cc/_stores/useDealTypeStore';
import type { SelectedLoc } from '@/app/cc/_types/types';
import { sendGA } from '@/app/cc/_util/sendGA';
const PartnerList = dynamic(() => import('./PartnerList'), {
  ssr: false
});
const INITIAL_LOC: SelectedLoc = {
  sido: {
    name: '서울',
    bjdCd: '1100000000'
  },
  gugun: {
    name: '강남구',
    bjdCd: '1168000000'
  },
  bjd: null,
  bjdCd: '1168000000'
};
export default function AnsimPartner() {
  const $ = _c(39);
  const dealType = useGetDealType();
  const [selectedLoc, setSelectedLoc] = useState(INITIAL_LOC);
  const [draftSelectedLoc, setDraftSelectedLoc] = useState(INITIAL_LOC);
  const [locSheetOpen, setLocSheetOpen] = useState(false);
  const {
    data: partnerData
  } = usePartnerList(selectedLoc.bjdCd);
  const partnerCount = partnerData?.totalCount ?? 0;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <br className="break" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={styles.title}><Text as="h3" category="display" variant="eb2" color="var(--color-gray-900)">우리동네{t0} <span className={styles.highlightText}>안심 중개사</span> 찾기</Text></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = dealType === "rent" ? "\uC804/\uC6D4\uC138 \uC784\uB300\uCC28" : "\uBD80\uB3D9\uC0B0 \uB9E4\uB9E4";
  let t3;
  if ($[2] !== t2) {
    t3 = <div className={styles.titleContent}>{t1}<Text as="p" category="body" variant="r1" color="var(--color-gray-700)">이실장이 검증한 파트너와 함께라면 <b>{t2}</b>도 안전합니다.</Text></div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Text as="span" category="heading" variant="m3" color="var(--color-gray-800)">검색 결과</Text>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== partnerCount) {
    t5 = <div className={styles.filterItem}>{t4}<Text as="span" category="heading" variant="sb3" color="var(--color-blue-500)">{partnerCount}</Text></div>;
    $[5] = partnerCount;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== selectedLoc) {
    t6 = () => {
      setDraftSelectedLoc(selectedLoc);
      sendGA("realtorArea");
      setLocSheetOpen(true);
    };
    $[7] = selectedLoc;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = selectedLoc.bjd && selectedLoc.bjd.name !== "all" ? `${selectedLoc.gugun?.name} ${selectedLoc.bjd.name}` : `${selectedLoc.sido.name} ${selectedLoc.gugun?.name}`;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Image src="/cc/image/icon_sliders.svg" alt="sliders" width={20} height={20} />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6 || $[11] !== t7) {
    t9 = <Button type="button" size="lg" variant="line" color="dark" onClick={t6}>{t7}{t8}</Button>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setLocSheetOpen(false);
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <BottomSheet.Header onClose={() => setLocSheetOpen(false)}>지역</BottomSheet.Header>;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <button type="button" className={styles.cancelButton} onClick={() => setLocSheetOpen(false)}>취소</button>;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== draftSelectedLoc) {
    t13 = () => {
      setSelectedLoc(draftSelectedLoc);
      setLocSheetOpen(false);
    };
    $[16] = draftSelectedLoc;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const t14 = draftSelectedLoc.gugun === null;
  let t15;
  if ($[18] !== t13 || $[19] !== t14) {
    t15 = <BottomSheet.CTA direction="row" layout="full" className={styles.bottomSheetCta}>{t12}<button type="button" className={styles.confirmButton} onClick={t13} disabled={t14}>확인</button></BottomSheet.CTA>;
    $[18] = t13;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== draftSelectedLoc) {
    t16 = <LocSheet selectedLoc={draftSelectedLoc} setSelectedLoc={setDraftSelectedLoc} />;
    $[21] = draftSelectedLoc;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== locSheetOpen || $[24] !== t15 || $[25] !== t16) {
    t17 = <BottomSheet isOpen={locSheetOpen} onClose={t10} header={t11} cta={t15}>{t16}</BottomSheet>;
    $[23] = locSheetOpen;
    $[24] = t15;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t17 || $[28] !== t5 || $[29] !== t9) {
    t18 = <div className={styles.partnerFilter}>{t5}{t9}{t17}</div>;
    $[27] = t17;
    $[28] = t5;
    $[29] = t9;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== selectedLoc) {
    t19 = <PartnerList selectedLoc={selectedLoc} />;
    $[31] = selectedLoc;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t18 || $[34] !== t19) {
    t20 = <div className={styles.partnerListContainer}>{t18}{t19}</div>;
    $[33] = t18;
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t20 || $[37] !== t3) {
    t21 = <section className={styles.AnsimPartner} id="ansim_partner"><div className={styles.inner}>{t3}{t20}</div></section>;
    $[36] = t20;
    $[37] = t3;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  return t21;
}